import { Link } from 'react-router-dom';
import { articles } from '../data/content';
import './Blog.css';

function Blog() {
  return (
    <div className="blog-page">
      <div className="page-hero">
        <h1>Artigos</h1>
        <p>Conteúdo sobre automação, integração e transformação digital para gerar valor ao seu negócio.</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="blog-list">
            {articles.map((article) => (
              <Link key={article.slug} to={`/blog/${article.slug}`} className="blog-item">
                <h2>{article.title}</h2>
                <p>{article.excerpt}</p>
                <span className="read-more">Ler artigo →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;
